module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av528-c2e02e6de02e9f5bc30e0e775d26d779.jpg";